import { Fragment } from "react";
import banner from "../assets/images/bannerDownloadMinecraft.jpg";
import { Button, Container } from "@mui/material";
import { HashLink } from "react-router-hash-link";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const FullVersion = () => {
  return (
    <Fragment>
      <img src={banner} alt="Generation AI" className="bannerImage" />
      <Container fixed>
        <div className="mainBody">
          <h1>Getting Started with Minecraft Education</h1>
        </div>
        <section>
          <h2>Great News!</h2>
          <p>You have the full version of Minecraft Education.</p>
          <p style={{ marginBottom: "2rem" }}>
            As your school has a fully licensed version of Minecraft Education,
            you have access to the entire range of teaching and learning content
            – including exciting new worlds and learning experiences focused
            upon developing coding skills and AI literacy!
          </p>
          <div className="btnListDownloads">
            <Button variant="outlined" href="/teacher-guide">
              Access Teacher Guides and Resources <ArrowForwardIcon />
            </Button>
            <HashLink to={"/#skillsHash"}>
              <Button variant="outlined">
                Let’s Go <ArrowForwardIcon />
              </Button>
            </HashLink>
          </div>
        </section>
      </Container>
    </Fragment>
  );
};
export default FullVersion;
